import { getBackendUrl } from "api/common";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import {
  AlternativeTransportLog,
  AlternativeTransportLogReq,
} from "shared/types/alternativeTransport";

export const postAlternativeTransportLog = (
  vehicleId: string,
  data: AlternativeTransportLogReq,
) =>
  mutationFnPOST<AlternativeTransportLog, AlternativeTransportLogReq>(
    `${getBackendUrl()}/alternativeTransportLogs/${vehicleId}`,
    data,
  );
